import type { Auth0Config } from '@opengov/psp-contract';

/** Where Auth0 returns the browser after signing in: the shell's one redirect URI. */
export const AUTH0_CALLBACK_PATH = '/auth0/callback';

/** Where Auth0 returns the browser after signing out. */
export const SIGNED_OUT_PATH = '/logout';

/**
 * Auth0 configuration sourced from the per-mode `.env.[mode]` file resolved
 * by Vite's `--mode` flag at build/serve time. Each supported mode
 * (development | integration | staging | production) has a committed env
 * file providing all three values, so the destructure is safe.
 */
export const auth0Config: Auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  redirectUri:
    typeof window !== 'undefined' ? `${window.location.origin}${AUTH0_CALLBACK_PATH}` : '',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
};
